/* tslint:disable */

export enum LicensedFeature {
  PublicLinks = 1,
  GuidelineEditor = 2,
  RetiredFeature = 3,
  Statistics = 4,
  Hub = 5,
  PublicReviewLinks = 6,
  PdfExport = 7,
  Workflow = 8,
}
